import { useEffect } from 'react';

// next
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';

// project import
import { DEFAULT_PATH } from 'config';

// types
import { GuardProps } from 'types/auth';
import Loader from 'components/Loader';

// ==============================|| GUEST GUARD ||============================== //

/** หน้า guest (login/register): ถ้ามี session แล้วให้ไป DEFAULT_PATH — ใช้ session จาก useSession โดยตรง ไม่ต้อง fetch /api/auth/protected ซ้ำ */
const GuestGuard = ({ children }: GuardProps) => {
  const { data: session, status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === 'loading') return;
    if (session?.user) {
      router.replace(DEFAULT_PATH);
    }
  }, [session, status, router]);

  if (status === 'loading' || session?.user) return <Loader />;

  return children;
};

export default GuestGuard;
